import { render, staticRenderFns } from "./AddressBox.vue?vue&type=template&id=ae9882f8&scoped=true"
import script from "./AddressBox.vue?vue&type=script&lang=js"
export * from "./AddressBox.vue?vue&type=script&lang=js"
import style0 from "./AddressBox.vue?vue&type=style&index=0&id=ae9882f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae9882f8",
  null
  
)

export default component.exports